import { TranslationsContextProvider } from '../features/Translations/providers/TranslationsContextProvider';
import { vhAdapter } from '../utils/vhAdapter';
import { Router } from './router';
import { ThemeContextProvider } from '../features/Theme/providers/ThemeContextProvider';
import { MeetContextProvider } from '../features/Meet/providers/MeetContextProvider';
import { ApiMeetRepository } from '../features/Meet/infrastructure/ApiMeetRepository';
import { useApp } from './hooks/useApp';
import { MediaContextProvider } from '../features/Media/providers/MediaContextProvider';
import { defaultTheme } from '../features/Theme/domain';
import { useEffect } from 'react';
import { setupDocumentLanguage } from '../features/Translations/services/i18n';
import { VideoCallContextProvider } from '../features/VideoCall/providers/VideoCallContextProvider';
import { ChatContextProvider } from '../features/Chat/providers/ChatContextProvider';

const meetRepository = new ApiMeetRepository();

export function App() {
	const { theme, loadingTheme, features } = useApp(meetRepository);

	useEffect(() => {
		vhAdapter();
		setupDocumentLanguage();
	}, []);

	return (
		<>
			{!loadingTheme && (
				<TranslationsContextProvider>
					<ThemeContextProvider theme={theme || defaultTheme}>
						<MeetContextProvider repository={meetRepository} features={features}>
							        <MediaContextProvider>
								<VideoCallContextProvider>
									<ChatContextProvider>
										<Router />
									</ChatContextProvider>
								</VideoCallContextProvider>
							</MediaContextProvider>
						</MeetContextProvider>
					</ThemeContextProvider>
			    </TranslationsContextProvider>
			)}
		</>
	);
}
